export const AiStarBig = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16 4L18.7153 13.2847L28 16L18.7153 18.7153L16 28L13.2847 18.7153L4 16L13.2847 13.2847L16 4Z'
      fill='url(#paint0_linear_10214_53594)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_10214_53594'
        x1='4'
        y1='16'
        x2='28'
        y2='16'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C9EBAE' />
        <stop offset='1' stopColor='#0073B0' />
      </linearGradient>
    </defs>
  </svg>
);
